import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';

@Component({
  selector: 'app-form-field-dynamic-link',
  templateUrl: './dynamic-link-form-field.component.html',
  styleUrls: ['dynamic-link-form-field.component.scss'],
  standalone: false,
})
export class DynamicLinkFormFieldComponent extends DataTypeComponent implements OnDestroy, OnInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  constructor(private http: HttpClient) {
    super();
  }

  hrefData: string;

  rowData: any;

  setRowData(entity: any) {
    this.rowData = entity;
  }

  ngOnInit() {}

  ngOnDestroy() {}

  performLink() {
    this.http.get(this.fieldConfig.selectUrl.replace('{id}', this.rowData.details.playerId)).subscribe((response) => {
      window.open(response['link'], '_blank');
    });
  }
}
